(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@platform/api/index"), require("@platform/base/index"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@platform/api/index", "@platform/base/index", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["@platform/template/index"] = factory(require("react"), require("@platform/api/index"), require("@platform/base/index"), require("react-dom"));
	else
		root["@platform/template/index"] = factory(root["React"], root["@platform/api/index"], root["@platform/base/index"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__5__) {
return 